<template>
<div>
  <div class="createPlayStep">
    <div class="headReturn">
      <span @click="toSetting"> <i class="el-icon-arrow-left"></i> 返回列表</span>
      <span style="margin: 0 20px">|</span>
      <span class="name">数据统计</span>
    </div>
    
    <input-form
          style="margin-top:20px;"
          :inputData="inputData"
          :pageName="pageName2"
         @toParentVal="querysearchContent"
    ></input-form>

<div class="section-right-content-box-table"  style="margin:20px" >
        <div class="table-box" > 
          <el-table
            ref="multipleTable"
            :data="recordData"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
            style="width: 100%; opacity: 1"
            @selection-change="handleSelectionChange"
            v-loading="loading"
          >
            <template slot="empty">
              <div>
                <img class="no_goods_img" src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="memberNick" label="客户昵称"></el-table-column>
            <!-- <el-table-column prop="level" label="会员等级">
                 <template slot-scope="scope">
              <span v-if="scope.row.level==1">一星会员</span>
              <span v-if="scope.row.level==2">二星会员</span>
              <span v-if="scope.row.level==3">三星会员</span>
              <span v-if="scope.row.level==4">四星会员</span>
              <span v-if="scope.row.level==5">五星会员</span>
            </template>
            </el-table-column> -->
            <el-table-column prop="activityName" label="活动名称"></el-table-column>
            <el-table-column  label="活动类型" width="100px;">
            <template slot-scope="scope">
              <span v-if="scope.row.activityType==0">未知</span>
              <span v-if="scope.row.activityType==11">新人优惠券</span>
              <span v-if="scope.row.activityType==12">会员券</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="参与时间"></el-table-column>
          <el-table-column  label="领取状态">
               <template slot-scope="scope">
              <span v-if="scope.row.receiveStatus==0">未知</span>
              <span v-if="scope.row.receiveStatus==1">未领取</span>
              <span v-if="scope.row.receiveStatus==2">已领取</span>
              <span v-if="scope.row.receiveStatus==3">已领取</span>
              <span v-if="scope.row.receiveStatus==4">领取失败</span>
            </template>
          </el-table-column>
            <el-table-column  label="操作" width="200">
               <template slot-scope="scope">
              <span v-if="scope.row.receiveStatus==1" style="cursor:pointer;color:#fe4d45" v-zoom='{from:pageName2,name:"标记领取"}' @click="cilckSign(scope.row.id,1)">标记为已领取</span>
              <span v-if="scope.row.receiveStatus==2">-</span>
              <span v-if="scope.row.receiveStatus==3" style="cursor:pointer;color:#fe4d45" v-zoom='{from:pageName2,name:"取消标记"}' @click="cilckSign(scope.row.id,0)">取消标记</span>
              <span v-if="scope.row.receiveStatus==4">-</span>
            </template>
            </el-table-column>
          </el-table>
           <el-pagination
          background
          style="text-align: right; margin-top: 20px; margin-right: 120px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="recordParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordTotal"
          :current-page="recordParams.current"
        >
        </el-pagination>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import inputForm from "../../../components/inputForm";
import {
  queryRecordPage,signRecord
} from "@/api/integralCenter/benefitActivityController";
export default {
    props: {
    ids: {
      type: String,
      default: 'hello world'
    },
    pageName:{
      type:String
    }
  },
  components: {
    inputForm,
  },
  created() {
  
  },
  data() {
    return {
      pageName2:this.pageName,
       recordParams: {
        //优惠券表格下方
        current: 1,
        size: 10,
        type:12,
        activityName:"",
        startTime:"",
        endTime:"",
        memberNick:"",
        activityId:"",
      },
      opendataAnalysis:1,
      username:"",
      startTime:"",
      endTime:"",
      status:"",
      recordData:[],
      typeType:11,
      id:"",
      status:"",
      loading: true,
      queryDTO: {},
      recordTotal: 0,
      inputData: [
         {
          name: "活动主题:",
          val: "username",
          placeholder: "请输入活动主题",
        },
        {
          name: "活动时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
    };
  },
    mounted() {
      this.queryRecordPage();
  },

  methods: {
        //获取新人优惠券活动
    queryRecordPage() {
        this.loading=true;
        // this.recordParams.activityId=28;
        this.recordParams.activityId=this.ids;
      queryRecordPage(this.recordParams)
        .then((res) => {
          console.log(res, "res");
          this.loading=false;
          this.recordData = res.data.records;
          this.recordTotal = Number(res.data.total);
        })
        .catch((res) => {

        });
    },
    //标记为已领取
    cilckSign(id,type){
      signRecord({id:id,type:type})
        .then((res) => {
            this.$message.success("标记成功")
            this.queryRecordPage();
        })
        .catch((res) => {

        });
    },
    //查询
    querysearchContent(from){
       this.recordParams.memberNick = from.username;
       this.recordParams.startTime = from.startTime;
       this.recordParams.endTime = from.endTime;
       this.queryRecordPage();
    },
        //重置
    resetContent() {
      this.recordParams= {
        //优惠券表格下方
        current: 1,
        size: 10,
        type:12,
        activityName:"",
        startTime:"",
        endTime:"",
        memberNick:"",
        activityId:this.ids,
      };
      this.queryPayRecord();
    },
    //关闭新人优惠券活动
    closestatistics(a){
      this.id=a
      closeBenefitActivity({id:this.id})
        .then((res) => {
          this.queryPayRecord();
          this.$message.success("关闭成功");
        })
        .catch((res) => {
          this.$message.error("关闭失败");
        });
    },
    //关闭删除
    deletestatistics(a){
      console.log(a);
      this.id=a;
      deleteBenefitActivity({id:this.id})
        .then((res) => {
          this.queryPayRecord();
          this.$message.success("删除成功");
        })
        .catch((res) => {
          this.$message.error(res);
        });
      
    },
    handleSelectionChange(){},
    handleCurrentChange(val) {
      this.recordParams.current = val;
      this.queryRecordPage();
    },
    handleSizeChange(val) {
      this.recordParams.size = val;
      this.queryRecordPage();
    },
    toSetting() {
      // let routeUrl = this.$router.resolve({
      //   path: "/integralCenter/integralCenter/memberPower",
      // });
      // window.open(routeUrl.href);
      this.$emit("returnBack");
    },
  },
};
</script>

<style scoped lang="scss">
.createPlayStep {
  min-width: 1000px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #2e3458;
      font-size: 16px;
      // font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      cursor: default;
    }
  }
}
.section-right-content-box-table{
  .auditSuccessful_ok1 {
    min-width: 950px;
    position: absolute;
    top: 45%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #cccccc;
    border-radius: 50%;
    opacity: 1;
  }
    .auditSuccessful_ok2 {
    position: absolute;
    top: 45%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #FFB95E;
    border-radius: 50%;
    opacity: 1;
  }
    .auditSuccessful_ok3 {
    position: absolute;
    top: 45%;
    left: 15px;
    line-height: 50%;
    width: 6px;
    height: 6px;
    background: #fe4d45;
    border-radius: 50%;
    opacity: 1;
  }
  .auditSuccessful_title {
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    opacity: 1;
  }
  .statistics{
    float: left;
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #fe4d45;
    margin-right:10px ;
    opacity: 1;
  }
  .closestatistics{
    font-size: 14px;
    // font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #7f85e9;
    margin-right:10px ;
    opacity: 1;
  }
}
</style>